import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, H5, M } from 'design-system-web';
import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import { Channel } from 'application-types';
import { CreateCoverageHoursPanel } from './CreateCoverageHoursPanel';
import styles from './CoverageHours.scss';

type Props = {
  channel?: Channel;
  categories?: WorkOrderModuleCategoriesSettings[];
};

export function CoverageHours({ channel, categories = [] }: Props) {
  const { t } = useTranslation();
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const handleOpenPanel = () => {
    if (!channel?._id) {
      window.Toast.show(
        t(
          'web.admin.serviceRequest.settings.coverageHours.create.channelError'
        )
      );

      return;
    }

    setIsPanelOpen(true);
  };

  return (
    <Flex direction="column" gap={6} className={styles.coverageHoursTab}>
      <div className={styles.sectionIntro}>
        <H5 className={styles.sectionTitle}>
          {t('web.admin.serviceRequest.settings.tabs.coverageHours')}
        </H5>
        <M className={styles.sectionDescription}>
          {t('web.admin.serviceRequest.settings.coverageHours.description')}
        </M>
      </div>
      <div className={styles.toolbar}>
        <Button
          variant="primary"
          size="large"
          testId="coverage-hours-create"
          onClick={handleOpenPanel}
        >
          {t(
            'web.admin.serviceRequest.settings.coverageHours.create.button'
          )}
        </Button>
      </div>

      {channel?._id && (
        <CreateCoverageHoursPanel
          isOpen={isPanelOpen}
          onClose={() => setIsPanelOpen(false)}
          channelId={channel._id}
          categories={categories}
        />
      )}
    </Flex>
  );
}
